import { AxiosResponse } from "axios";

import { axiosInstance } from "./index";
import { ApiResponse, ApiRequest } from "./types";

/** ====================================================
 * アカウント
 ==================================================== */
export const getManagedPartnerUsers = async () => {
  const response = await axiosInstance.get<ApiResponse.ManagedPartnerUser[]>(
    `/api/jobs/v1/accounts/partner_users`
  );
  return response;
};

export const getManagedPartnerUser = async (
  params: ApiRequest.GetManagedPartnerUser
) => {
  const response = await axiosInstance.get<ApiResponse.ManagedPartnerUser>(
    `/api/jobs/v1/accounts/partner_users/${params.partner_user_id}`
  );
  return response;
};

export const deleteManagedPartnerUser = async (
  params: ApiRequest.DeleteManagedPartnerUser
) => {
  const response = await axiosInstance.delete(
    `/api/jobs/v1/accounts/partner_users/${params.partner_user_id}`
  );
  return response;
};

export const createManagedPartnerUser = async (
  params: ApiRequest.CreateManagedPartnerUser
) => {
  const response = await axiosInstance.post(
    `/api/jobs/v1/accounts/partner_users`,
    {
      email: params.email,
      name: params.name,
      admin: params.admin
    }
  );
  return response;
};

export const updateManagedPartnerUser = async (
  params: ApiRequest.UpdateManagedPartnerUser
) => {
  const response = await axiosInstance.patch(
    `/api/jobs/v1/accounts/partner_users/${params.partner_user_id}`,
    {
      email: params.email,
      name: params.name,
      password: params.password,
      admin: params.admin
    }
  );
  return response;
};

export const getRecruitmentNotificationSetting = async () => {
  const response = await axiosInstance.get<
    ApiResponse.RecruitmentNotificationSetting
  >(`/api/jobs/v1/accounts/notification_settings`);
  return response;
};

export const getAccountsFollowCompanies = async () => {
  const response = await axiosInstance.get<
    ApiResponse.GetAccountsFollowCompanies
  >("/api/jobs/v1/accounts/follow_companies");
  return response;
};

export const updateRecruitmentNotificationSetting = async (
  params: ApiRequest.UpdateRecruitmentNotificationSetting
) => {
  const response = await axiosInstance.patch<
    ApiResponse.RecruitmentNotificationSetting
  >(`/api/jobs/v1/accounts/notification_settings`, params);
  return response;
};

export const getAccountsPopularCompanies = async () => {
  const response = await axiosInstance.get<
    ApiResponse.GetAccountsPopularCompanies
  >("/api/jobs/v1/accounts/popular_companies");
  return response;
};

export const getAccountsFollowUniversities = async () => {
  const response = await axiosInstance.get<
    ApiResponse.GetAccountsFollowUniversities
  >("/api/jobs/v1/accounts/follow_universities");
  return response;
};

export const getAccountsPopularUniversities = async () => {
  const response = await axiosInstance.get<
    ApiResponse.GetAccountsPopularUniversities
  >("/api/jobs/v1/accounts/popular_universities");
  return response;
};

export const getContractInformation = async (
  params?: ApiRequest.getContractInformation
) => {
  const response = await axiosInstance.get<ApiResponse.ContractInformations>(
    `/api/jobs/v1/accounts/contract_informations`,
    { params }
  );
  return response;
};

export const getIntegrationSonarToken = async () => {
  const response = await axiosInstance.get<
    ApiResponse.GetAccountsIntegrationSonarToken
  >("/api/jobs/v1/accounts/sonar_tokens");
  return response;
};

export const updateIntegrationSonarToken = async (
  params: ApiRequest.UpdateIntegrationSonarToken
) => {
  const response = await axiosInstance.patch(
    `/api/jobs/v1/accounts/sonar_tokens`,
    params
  );
  return response;
};

export const deleteIntegrationSonarToken = async () => {
  const response = await axiosInstance.delete(
    "/api/jobs/v1/accounts/sonar_tokens"
  );
  return response;
};

export const getScoutIwebIntegrations = async () => {
  const response = await axiosInstance.get<
    ApiResponse.GetScoutIwebIntegrations
  >("/api/jobs/v1/accounts/scout_iweb_integrations");
  return response;
};

export const updateScoutIwebIntegrations = async (
  params: ApiRequest.UpdateScoutIwebIntegrations
) => {
  const response = await axiosInstance.patch(
    `/api/jobs/v1/accounts/scout_iweb_integrations`,
    params
  );
  return response;
};

export const getEventIwebIntegrations = async () => {
  const response = await axiosInstance.get<
    ApiResponse.GetEventIwebIntegrations
  >("/api/jobs/v1/accounts/event_iweb_integrations");
  return response;
};

export const updateEventIwebIntegrations = async (
  params: ApiRequest.UpdateEventIwebIntegrations
) => {
  const response = await axiosInstance.patch(
    `/api/jobs/v1/accounts/event_iweb_integrations`,
    params
  );
  return response;
};

export const getIwebIntegrationSetting = async () => {
  const response = await axiosInstance.get<
    ApiResponse.GetIwebIntegrationSetting
  >("/api/jobs/v1/accounts/iweb_integration_settings");
  return response;
};

/** ====================================================
 * イベント
 ==================================================== */
export const getJobEvents = async (params: ApiRequest.JobEvents) => {
  const response = await axiosInstance.get<ApiResponse.JobEventList>(
    `/api/jobs/v1/events`,
    {
      params
    }
  );
  return response;
};

export const getEventGraduateYears = async () => {
  const response = await axiosInstance.get<ApiResponse.EventGraduateYears>(
    `/api/jobs/v1/events/graduate_years`
  );
  return response;
};

/** メールテンプレート取得 */
export async function getEventMailTemplateVariables() {
  try {
    const response = await axiosInstance.get<
      ApiResponse.JobEventMailTemplateVariable
    >(`/api/jobs/v1/mail_template_variables`);

    return response;
  } catch (error) {
    throw error;
  }
}

/** スケジュールのメールテンプレート取得 */
export async function getJobEventDraftEntryMailTemplates(
  params: ApiRequest.GetJobEventDraftEntryMailTemplates
) {
  try {
    const response = await axiosInstance.get<
      ApiResponse.GetJobEventEntryMailTemplates
    >(
      `/api/jobs/v1/draft_schedules/${params.draftScheduleId}/entry_mail_template`
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** 直近開催のイベント一覧取得 */
export const getComingEvents = async () => {
  try {
    const response = await axiosInstance.get<ApiResponse.GetComingEvents>(
      `/api/jobs/v1/coming_events`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

/** 下書きスケジュールのメールテンプレート更新 */
export const updateJobEventDraftEntryMailTemplates = async (
  params: ApiRequest.UpdateJobEventDraftEntryMailTemplates
) => {
  try {
    const response = await axiosInstance.put<
      ApiResponse.UpdateJobEventDraftEntryMailTemplates
    >(
      `/api/jobs/v1/draft_schedules/${params.draftScheduleId}/entry_mail_template`,
      params
    );

    return response;
  } catch (error) {
    throw error;
  }
};

/** スケジュールのメールテンプレート取得 */
export async function getJobEventEntryMailTemplates(
  params: ApiRequest.GetJobEventEntryMailTemplates
) {
  try {
    const response = await axiosInstance.get<
      ApiResponse.GetJobEventEntryMailTemplates
    >(`/api/jobs/v1/schedules/${params.scheduleId}/entry_mail_template`);

    return response;
  } catch (error) {
    throw error;
  }
}

/** スケジュールのメールテンプレート更新 */
export const updateJobEventEntryMailTemplates = async (
  params: ApiRequest.UpdateJobEventEntryMailTemplates
) => {
  try {
    const response = await axiosInstance.put<
      ApiResponse.UpdateJobEventEntryMailTemplates
    >(
      `/api/jobs/v1/schedules/${params.scheduleId}/entry_mail_template`,
      params
    );

    return response;
  } catch (error) {
    throw error;
  }
};

/** メール配信設定の更新 */
export const updateJobEventMailNotificationTypes = async (
  params: ApiRequest.UpdateJobEventMailNotificationTypes
) => {
  try {
    await axiosInstance.put(
      `/api/jobs/v1/events/${params.eventId}/mail_notification_types`,
      {
        mail_notification_types: params.mail_notification_types
      }
    );
  } catch (error) {
    throw error;
  }
};

/** スケジュールの取得 */
export const getJobEventSchedules = async (
  params: ApiRequest.GetJobEventSchedulesParams
) => {
  try {
    const response = await axiosInstance.get<ApiResponse.JobEventSchedules>(
      `/api/jobs/v1/events/${params.eventId}/unpublished_schedules`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/** イベントの取得 */
export async function getJobEvent(params: ApiRequest.GetJobEventParams) {
  try {
    const response = await axiosInstance.get<ApiResponse.JobEvent>(
      `/api/jobs/v1/events/${params.eventId}/draft_event`
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** イベントの下書き保存 */
export async function updateJobEvent(data: ApiRequest.DraftJobEvent) {
  try {
    const response = await axiosInstance.post<ApiResponse.PostJobEvent>(
      `/api/jobs/v1/draft_event`,
      data
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** イベントの公開申請 */
export async function submitJobEvent(data: ApiRequest.JobEvent) {
  try {
    const response = await axiosInstance.post<ApiResponse.PostJobEvent>(
      `/api/jobs/v1/submit_event`,
      data
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** 掲載依頼取り下げ */
export async function withdrawJobEventSubmission(
  params: ApiRequest.GetJobEventParams
) {
  try {
    const response = await axiosInstance.patch(
      `/api/jobs/v1/events/${params.eventId}/withdraw_submission`
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** イベント複製 */
export async function duplicateJobEvent(params: ApiRequest.GetJobEventParams) {
  try {
    const response = await axiosInstance.post<
      ApiResponse.JobEvent["draft_event"]
    >(`/api/jobs/v1/events/${params.eventId}/copy`);

    return response;
  } catch (error) {
    throw error;
  }
}

/** イベントアーカイブ */
export async function archiveJobEvent(params: ApiRequest.GetJobEventParams) {
  try {
    const response = await axiosInstance.patch(
      `/api/jobs/v1/events/batch_archive`,
      {
        event_ids: [params.eventId]
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** イベントアーカイブ解除 */
export async function unarchiveJobEvent(params: ApiRequest.GetJobEventParams) {
  try {
    const response = await axiosInstance.patch(
      `/api/jobs/v1/events/batch_unarchive`,
      {
        event_ids: [params.eventId]
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** スケジュール受付停止 */
export async function closeJobEventSchedule(
  params: ApiRequest.CancelJobEventSchedule
) {
  try {
    const response = await axiosInstance.patch(
      `/api/jobs/v1/draft_schedules/${params.scheduleId}/close_now`,
      { original_schedule_id: params.originalScheduleId }
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** ====================================================
 * OC主催イベント(旧チェックイン)
 ==================================================== */
export const getSponsoredEvents = async (
  params: ApiRequest.SponsoredEvents
) => {
  const response = await axiosInstance.get<ApiResponse.SponsoredEventList>(
    "/api/jobs/v1/sponsored_events",
    {
      params: params
    }
  );
  return response;
};

// TODO: 卒年取得のAPIが複数あるため整理・統一する
export const getSponsoredEventAvailableGraduateYears = async () => {
  const response = await axiosInstance.get<
    ApiResponse.SponsoredAvailableGraduateYears
  >("/api/v1/available_graduate_years");
  return response;
};

export const getSponsoredEventEntryCheckins = async (
  params: ApiRequest.SponsoredEventEntryCheckins
) => {
  const response = await axiosInstance.get<
    ApiResponse.SponsoredEventEntryCheckinList
  >(`/api/jobs/v1/sponsored_events/entry_checkins`, {
    params: params
  });
  return response;
};

export const getSponsoredEvent = async (params: ApiRequest.SponsoredEvent) => {
  const response = await axiosInstance.get<ApiResponse.SponsoredEvent>(
    `/api/jobs/v1/events/${params.eventId}/event_info`,
    {
      params: params
    }
  );
  return response;
};

export const getSponsoredEventEntryCheckinSearchOptions = async (
  params: ApiRequest.SponsoredEventsSearchOptions
) => {
  const response = await axiosInstance.get<
    ApiResponse.SponsoredEventEntryCheckinSearchOptions
  >(`/api/jobs/v1/sponsored_events/entry_checkins/search_options`, {
    params
  });
  return response;
};

export const startGenerateEntryCheckinsCsv = async (
  params: ApiRequest.EntryCheckinsGenerateCsv
) => {
  const response = await axiosInstance.post(
    `api/jobs/v1/sponsored_events/entry_checkins/csv_download_request`,
    params
  );
  return response;
};

/** ====================================================
 * 応募者
 ==================================================== */
/** 応募者一覧の取得 */
export const getPartnerEntryUsers = async (
  params: ApiRequest.PartnerEntryUsers
): Promise<AxiosResponse<ApiResponse.PartnerEntryUserList>> => {
  const response = await axiosInstance.get<ApiResponse.PartnerEntryUserList>(
    "/api/jobs/v1/partner_entry_users",
    {
      params: params
    }
  );
  return response;
};

/** 応募者をお気に入りに追加 */
export const updatePartnerEntryUserStar = async (
  params: ApiRequest.UpdatePartnerEntryUserStar
): Promise<AxiosResponse> => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/partner_entry_users/${params.partner_entry_user_id}/star`
  );
  return response;
};

/** 応募者をお気に入りから削除 */
export const deletePartnerEntryUserStar = async (
  params: ApiRequest.UpdatePartnerEntryUserStar
): Promise<AxiosResponse> => {
  const response = await axiosInstance.delete(
    `/api/jobs/v1/partner_entry_users/${params.partner_entry_user_id}/star`
  );
  return response;
};

/** 応募者の検索オブション取得 */
export const getPartnerEntryUserSearchOptions = async (): Promise<AxiosResponse<
  ApiResponse.PartnerEntryUserSearchOptions
>> => {
  const response = await axiosInstance.get<
    ApiResponse.PartnerEntryUserSearchOptions
  >(`/api/jobs/v1/partner_entry_users/search_options`);
  return response;
};

/** 応募者の詳細情報を取得する */
export const getApplicantUser = async (
  params: ApiRequest.GetApplicantUser
): Promise<AxiosResponse<ApiResponse.PartnerEntryUserDetail>> => {
  const response = await axiosInstance.get<ApiResponse.PartnerEntryUserDetail>(
    `/api/jobs/v1/applicants/users/${params.user_id}`
  );
  return response;
};

/** 応募者のイベントごとに選択可能なスケジュールを取得する */
export const getScheduleOptions = async (
  params: ApiRequest.GetScheduleOptions
) => {
  const response = await axiosInstance.get<ApiResponse.GetScheduleOptions>(
    `/api/jobs/v1/events/${params.event_id}/users/${params.user_id}/schedules`
  );
  return response;
};

/** 応募者の参加中のスケジュールを更新する */
export const updateApplyingSchedule = async ({
  previous_schedule_id,
  next_schedule_id,
  user_id
}: ApiRequest.UpdateApplyingSchedule) => {
  const response = await axiosInstance.patch(
    `/api/jobs/v1/schedules/${previous_schedule_id}/users/${user_id}`,
    { next_schedule_id }
  );
  return response;
};

export const bulkUpdateSelectionStatus = async (
  params: ApiRequest.UpdateSelectionStatus
) => {
  const response = await axiosInstance.patch(
    `/api/jobs/v1/partner_entry_users/selection_status`,
    params
  );
  return response;
};

/** 応募者の選考ステータスを変更する */
export const updatePartnerEntryUserSelectionStatus = async (
  params: ApiRequest.UpdatePartnerEntryUserSelectionStatus
): Promise<AxiosResponse> => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/partner_entry_users/${params.partner_entry_user_id}/selection_status`,
    {
      selection_status: params.selection_status
    }
  );
  return response;
};

/** 応募者のイベントステータスを変更する */
export const updatePartnerEntryUserEntryStatus = async (
  params: ApiRequest.UpdatePartnerEntryUserEntryStatus
): Promise<AxiosResponse> => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/entries/${params.entry_id}/state`,
    {
      state: params.state
    }
  );
  return response;
};

/** 応募者のメモを取得する */
export const getPartnerEntryUserMemos = async (
  params: ApiRequest.GetPartnerEntryUserMemos
): Promise<AxiosResponse<ApiResponse.PartnerEntryUserMemos>> => {
  const response = await axiosInstance.get<ApiResponse.PartnerEntryUserMemos>(
    "/api/jobs/v1/partner_entry_user_memos",
    {
      params: params
    }
  );
  return response;
};

/** 応募者のメモを新規作成する */
export const createPartnerEntryUserMemo = async (
  params: ApiRequest.CreatePartnerEntryUserMemos
): Promise<AxiosResponse> => {
  const response = await axiosInstance.post(
    "/api/jobs/v1/partner_entry_user_memos",
    {
      partner_entry_user_id: params.partner_entry_user_id,
      content: params.content
    }
  );
  return response;
};

/** 応募者に紐づくイベント一覧を取得する */
export const getApplicantUserEntries = async (
  params: ApiRequest.GetApplicantUserEntries
): Promise<AxiosResponse<ApiResponse.PartnerEntryUserEvents>> => {
  const response = await axiosInstance.get<ApiResponse.PartnerEntryUserEvents>(
    `/api/jobs/v1/applicants/users/${params.user_id}/entries`
  );
  return response;
};

/** 応募者に紐づくスカウトエントリーを取得する */
export const getApplicantUserScoutEntry = async (
  params: ApiRequest.GetApplicantUserScoutEntry
): Promise<AxiosResponse<ApiResponse.UserScoutEntry>> => {
  const response = await axiosInstance.get<ApiResponse.UserScoutEntry>(
    `/api/jobs/v1/applicants/users/${params.user_id}/scout_entries`
  );
  return response;
};

/** 応募者の履歴書をPDFで取得する (inline が true のときプレビュー, false のときダウンロード) */
export const getPartnerEntryUserResumePdf = async (
  params: ApiRequest.GetPartnerEntryUserResumePdf
): Promise<AxiosResponse> => {
  // TODO: データ型わからないので後で追記する
  const response = await axiosInstance.get(
    `/api/jobs/v1/partner_entry_users/${params.partner_entry_user_id}/resume.pdf`,
    {
      params: {
        inline: params.inline
      }
    }
  );
  return response;
};

/** レジュメを取得する */
export const getPartnerEntryUserResumeAnswers = async (
  params: ApiRequest.GetPartnerEntryUserResumeAnswers
): Promise<AxiosResponse<ApiResponse.PartnerEntryUserResumeAnswers>> => {
  const response = await axiosInstance.get<
    ApiResponse.PartnerEntryUserResumeAnswers
  >(`/api/jobs/v1/entries/${params.entry_id}/resume_preview`);
  return response;
};

/** CSVダウンロード */
export const startGeneratePartnerEntryUsersCsv = async (
  params: ApiRequest.PartnerEntryUsersGenerateCsv
) => {
  const response = await axiosInstance.post(
    `/api/jobs/v1/partner_entry_users/csv_download_request`,
    params
  );
  return response;
};

/** 特別講演出席者の検索オブション取得 */
export const getOfflineCourseAttendeeSearchOptions = async (): Promise<AxiosResponse<
  ApiResponse.CourseAtendeeSearchOptions
>> => {
  const response = await axiosInstance.get<
    ApiResponse.CourseAtendeeSearchOptions
  >(`/api/jobs/v1/course_attendees/search_options`);
  return response;
};

/** 特別講演出席者一覧 */
export const getCourseAttendees = async (
  params: ApiRequest.GetCourseAttendees
): Promise<AxiosResponse<ApiResponse.CourseAttendees>> => {
  const response = await axiosInstance.get<ApiResponse.CourseAttendees>(
    `/api/jobs/v1/course_attendees`,
    { params }
  );

  return response;
};

/** 特別講演出席者CSVダウンロード */
export const startGenerateCourseAttendeesCsv = async (
  params: ApiRequest.CourseAttendeesGenerateCsv
) => {
  const response = await axiosInstance.post(
    `/api/jobs/v1/course_attendees/csv_download_requests`,
    params
  );

  return response;
};

/** 座談会出席者の検索オブション取得 */
export const getRoundtableAttendeeSearchOptions = async (
  params: ApiRequest.GetRoundtableAttendeeSearchOptions
): Promise<AxiosResponse<ApiResponse.RoundtableAtendeeSearchOptions>> => {
  const response = await axiosInstance.get<
    ApiResponse.RoundtableAtendeeSearchOptions
  >(`/api/jobs/v1/roundtable_attendees/search_options`, {
    params
  });
  return response;
};

/** 座談会出席者一覧を取得 */
export const getRoundtableAttendees = async (
  params: ApiRequest.GetRoundtableAttendees
): Promise<AxiosResponse<ApiResponse.RoundtableAtendees>> => {
  const response = await axiosInstance.get<ApiResponse.RoundtableAtendees>(
    `/api/jobs/v1/roundtable_attendees`,
    {
      params: params
    }
  );
  return response;
};

/** 座談会CSVダウンロード */
export const startGenerateRoundtableAtendeesCsv = async (
  params: ApiRequest.RoundtableAtendeesGenerateCsv
) => {
  const response = await axiosInstance.post(
    `/api/jobs/v1/roundtable_attendees/csv_download_requests`,
    params
  );
  return response;
};

/** 企業ページとイベントに記入不可な文字一覧を取得 */
export const getProhibitedWords = async (): Promise<AxiosResponse<
  ApiResponse.ProhibitedWords
>> => {
  const response = await axiosInstance.get<ApiResponse.ProhibitedWords>(
    `/api/jobs/v1/prohibited_words`,
    {}
  );
  return response;
};

/** ====================================================
 * 動画エントリー
 ==================================================== */
/** 動画エントリー一覧の取得 */
export const getVideoBundleUnlockingLogs = async (
  params: ApiRequest.VideoBundleUnlockingLogs
): Promise<AxiosResponse<ApiResponse.VideoBundleUnlockingLogsList>> => {
  const response = await axiosInstance.get<
    ApiResponse.VideoBundleUnlockingLogsList
  >("/api/jobs/v1/video_bundle_unlocking_logs", {
    params: params
  });
  return response;
};

/** 動画エントリー一覧で検索するときの選択肢の取得 */
export const getVideoBundleUnlockingLogSearchOptions = async (): Promise<AxiosResponse<
  ApiResponse.VideoBundleUnlockingLogsSearchOptions
>> => {
  const response = await axiosInstance.get<
    ApiResponse.VideoBundleUnlockingLogsSearchOptions
  >(`/api/jobs/v1/video_bundle_unlocking_logs/search_options`);
  return response;
};

/** 動画エントリーのリストのCSVダウンロード */
export const postVideoBundleUnlockingLogsCsvDownloadRequests = async (
  params: ApiRequest.VideoBundleUnlockingLogsCsvDownloadRequest
) => {
  const response = await axiosInstance.post(
    `/api/jobs/v1/video_bundle_unlocking_logs/csv_download_requests`,
    params
  );
  return response;
};

/** ====================================================
 * イベント応募者
 ==================================================== */
export const getEventEntryUsers = async (
  params: ApiRequest.EventEntryUsers
): Promise<AxiosResponse<ApiResponse.EventEntryUserList>> => {
  const response = await axiosInstance.get<ApiResponse.EventEntryUserList>(
    `/api/jobs/v1/events/${params.eventId}/entries`,
    {
      params: params
    }
  );
  return response;
};

export const getEventEntryUserSearchOptions = async (
  params: ApiRequest.EventEntryUsersSearchOptions
): Promise<AxiosResponse<ApiResponse.EventEntryUserSearchOptions>> => {
  const response = await axiosInstance.get<
    ApiResponse.EventEntryUserSearchOptions
  >(`/api/jobs/v1/events/${params.eventId}/entries/search_options`, {
    params: params
  });
  return response;
};

export const updateEventEntryUserStar = async (
  params: ApiRequest.updateEventEntryUserStar
): Promise<AxiosResponse> => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/events/entries/${params.entryId}/star`
  );
  return response;
};

export const deleteEventEntryUserStar = async (
  params: ApiRequest.deleteEventEntryUserStar
): Promise<AxiosResponse> => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/events/entries/${params.entryId}/unstar`
  );
  return response;
};

/** CSVダウンロード */
export const startGenerateEventEntriesCsv = async (
  params: ApiRequest.EventEntryUsersGenerateCsv
) => {
  const response = await axiosInstance.post(
    `/api/jobs/v1/events/${params.eventId}/entries/csv_download_request`,
    params
  );
  return response;
};

/** ====================================================
 * ライブ申込者一覧
 ==================================================== */
export const getSponsoredEventEntryApplicants = async (
  params: ApiRequest.SponsoredEventEntryApplicants
): Promise<AxiosResponse<ApiResponse.SponsoredEventEntryApplicantList>> => {
  const response = await axiosInstance.get<
    ApiResponse.SponsoredEventEntryApplicantList
  >(`/api/jobs/v1/sponsored_events/entry_applicants`, {
    params: params
  });
  return response;
};

/** 検索オプション */
export const getSponsoredEventEntryApplicantSearchOptions = async (): Promise<AxiosResponse<
  ApiResponse.SponsoredEventEntryApplicantSearchOptions
>> => {
  const response = await axiosInstance.get<
    ApiResponse.SponsoredEventEntryApplicantSearchOptions
  >(`/api/jobs/v1/sponsored_events/entry_applicants/search_options`);
  return response;
};

/** CSVダウンロード */
export const startGenerateSponsoredEventEntryApplicantsCsv = async (
  params: ApiRequest.SponsoredEventEntryApplicantsGenerateCsv
) => {
  const response = await axiosInstance.post(
    `/api/jobs/v1/sponsored_events/entry_applicants/csv_download_request`,
    params
  );
  return response;
};

/** ====================================================
 * ファイルダウンロード
 ==================================================== */
export const getFiles = async (params: ApiRequest.GetFiles) => {
  const response = await axiosInstance.get<ApiResponse.PartnerFiles>(
    `/api/jobs/v1/partner_files`,
    {
      params: {
        file_name: params.file_name,
        agent_scout: params.agent_scout,
        limit: params.limit,
        offset: params.offset,
        order: params.order
      }
    }
  );
  return response;
};

export const getDownloadFile = async (params: ApiRequest.GetDownloadFile) => {
  const response = await axiosInstance.get<ApiResponse.GetPartnerFile>(
    `/api/jobs/v1/partner_file_downloads/${params.file_id}`
  );
  return response;
};

export const getPartnerUsersPrivileges = async () => {
  const response = await axiosInstance.get<ApiResponse.PartnerUsersPrivileges>(
    `/api/jobs/v1/accounts/privileges`
  );
  return response;
};

export const updatePartnerUserPrivileges = async (
  params: ApiRequest.UpdatePartnerUserPrivileges
) => {
  const response = await axiosInstance.patch(
    `/api/jobs/v1/accounts/privileges`,
    params
  );
  return response;
};

export const getCompanyLogo = async () => {
  const response = await axiosInstance.get<ApiResponse.GetCompanyLogo>(
    `/api/jobs/v1/accounts/company_logos`
  );
  return response;
};

export const updateCompanyLogo = async (params: FormData) => {
  const response = await axiosInstance.patch(
    `/api/jobs/v1/accounts/company_logos`,
    params
  );
  return response;
};

/** ====================================================
 * 企業ページ
 ==================================================== */
/** 全バージョンの取得 */
export const getOfficials = async () => {
  const response = await axiosInstance.get<ApiResponse.Officials>(
    "/api/jobs/v1/officials"
  );
  return response;
};

/** バージョンの新規作成 */
export const createOfficial = async (params: ApiRequest.CreateOfficial) => {
  const response = await axiosInstance.post<ApiResponse.Official>(
    "/api/jobs/v1/officials",
    params
  );
  return response;
};

/** バージョン詳細の取得 */
export const getOfficial = async (params: ApiRequest.GetOfficial) => {
  const response = await axiosInstance.get<ApiResponse.OfficialDetail>(
    `/api/jobs/v1/officials/${params.official_id}`
  );
  return response;
};

/** バージョン詳細の更新 */
export const updateOfficial = async (params: ApiRequest.UpdateOfficial) => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/officials/${params.id}`,
    params
  );
  // 保存成功した場合はdataなし、ステータス204
  return response;
};

/** バージョンの掲載依頼 */
export const confirmOfficial = async (params: ApiRequest.ConfirmOfficial) => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/officials/${params.official_id}/confirm`,
    {
      start_at: params.start_at,
      comment: params.comment
    }
  );
  // 成功した場合はdataなし、ステータス204
  return response;
};

/** バージョンの掲載依頼取り下げ */
export const unconfirmOfficial = async (
  params: ApiRequest.UnconfirmOfficial
) => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/officials/${params.official_id}/unconfirm`
  );
  // 成功した場合はdataなし、ステータス204
  return response;
};

export const updateEventStatus = async (
  params: ApiRequest.UpdateEventStatus
) => {
  const response = await axiosInstance.put(
    `/api/jobs/v1/events/entries/event_status`,
    params
  );
  return response;
};
/** ====================================================
 * 応募者・申込者一覧CSV出力カラム
 ==================================================== */
export const getPartnerEntryCsvColumns = async () => {
  const response = await axiosInstance.get<ApiResponse.PartnerEntryCsvColumns>(
    `/api/jobs/v1/partner_entry_csv_columns`,
    {}
  );

  return response;
};

export const upsertPartnerEntryCsvColumns = async (
  params: ApiRequest.UpsertPartnerEntryCsvColumns
) => {
  const response = await axiosInstance.post(
    `/api/jobs/v1/partner_entry_csv_columns/bulk_upsert`,
    params
  );
  return response;
};

/** ====================================================
 * パフォーマンス
 ==================================================== */
export const getPerformanceEvent = async (
  params: ApiRequest.GetPerformanceEvent
): Promise<AxiosResponse<ApiResponse.PerformanceEvents>> => {
  const response = await axiosInstance.get<ApiResponse.PerformanceEvents>(
    `/api/jobs/v1/reports/event_reports`,
    { params }
  );
  return response;
};

export const generatePerformanceEventCsv = async (
  params: ApiRequest.CreatePerformanceEventCsv
): Promise<AxiosResponse> => {
  const response = await axiosInstance.post<ApiResponse.PerformanceEvents>(
    `/api/jobs/v1/reports/events/${params.event_id}/event_reports/csv_download_request`,
    params
  );
  return response;
};

export const getPerformanceOfficial = async (
  params: ApiRequest.GetPerformanceOfficial
): Promise<AxiosResponse<ApiResponse.PerformanceOfficial>> => {
  const response = await axiosInstance.get<ApiResponse.PerformanceOfficial>(
    `/api/jobs/v1/reports/official_reports`,
    { params }
  );
  return response;
};

export const generatePerformanceOfficialCsv = async (
  params: ApiRequest.CreatePerformanceOfficialCsv
): Promise<AxiosResponse> => {
  const response = await axiosInstance.post<ApiResponse.PerformanceOfficial>(
    `/api/jobs/v1/reports/official_reports/csv_download_request`,
    params
  );
  return response;
};

export const getPerformanceScout = async (
  params: ApiRequest.GetPerformanceScout
): Promise<AxiosResponse<ApiResponse.PerformanceScouts>> => {
  const response = await axiosInstance.get<ApiResponse.PerformanceScouts>(
    `/api/jobs/v1/reports/scout_reports`,
    { params }
  );
  return response;
};

export const generatePerformanceScoutCsv = async (
  params: ApiRequest.CreatePerformanceScoutCsv
): Promise<AxiosResponse> => {
  const response = await axiosInstance.post<ApiResponse.PerformanceScouts>(
    `/api/jobs/v1/reports/scouts/${params.template_id}/scout_reports/csv_download_request`,
    params
  );
  return response;
};

export const getAgentScoutAcceptances = async (
  params: ApiRequest.AgentScoutAcceptances
) => {
  const response = await axiosInstance.get<
    ApiResponse.AgentScoutAcceptanceList
  >(`/api/jobs/v1/agent_scout/acceptances`, {
    params: params
  });
  return response;
};

/** 受諾者の選考ステータスを変更する */
export const updateAgentScoutAcceptanceSelectionStatus = async (
  params: ApiRequest.UpdateAgentScoutAcceptanceSelectionStatus
): Promise<AxiosResponse> => {
  return await axiosInstance.patch(
    `api/jobs/v1/agent_scout/acceptances/${params.agent_scout_acceptance_id}/selection_status`,
    {
      selection_status: params.selection_status
    }
  );
};

export const getAgentScoutAcceptanceSearchOptions = async () => {
  const response = await axiosInstance.get<
    ApiResponse.AgentScoutAcceptanceSearchOptions
  >(`/api/jobs/v1/agent_scout/acceptances/search_options`);
  return response;
};

export const startGenerateAgentScoutAcceptancesCsv = async (
  params: ApiRequest.AgentScoutAcceptancesGenerateCsv
) => {
  const response = await axiosInstance.post(
    `api/jobs/v1/agent_scout/acceptances/csv_download_request`,
    params
  );
  return response;
};

export const getAgentScoutAcceptance = async (
  params: ApiRequest.GetAgentScoutAcceptance
): Promise<AxiosResponse<ApiResponse.AgentScoutAcceptanceDetail>> => {
  const response = await axiosInstance.get<
    ApiResponse.AgentScoutAcceptanceDetail
  >(`/api/jobs/v1/agent_scout/acceptances/${params.user_id}`);
  return response;
};

export const updateNotificationSettingToUnsubscribe = async (
  params: ApiRequest.UpdateNotificationSettingToUnsubscribe
) => {
  const response = await axiosInstance.post(
    `api/jobs/v1/accounts/notification_settings/unsubscribe`,
    params
  );
  return response;
};
